export const projectsData = [
    {
        id: 1,
        projectName: 'CARE CLINICK',
        projectDesc: 'This project is An All Patients Can take An Appointment for their doctor and checkUp also.',
        tags: ['NODE JS', 'EJS', 'EXPRESS'],
        code: 'https://github.com/shaheedulaslam/CareClinick',
        demo: 'www.careclinick.online',
        image: 'https://previews.123rf.com/images/prettyvectors/prettyvectors1809/prettyvectors180900046/109434813-woman-patient-online-web-medicine-clinic-consultation-concept-vector-flat-cartoon-isolated.jpg'
    },
    {
        id: 2,
        projectName: 'Al-Qazi Studio',
        projectDesc: 'This Project is freelance Work and it is a PhotoGraphy Studio Management Site it is based on DUBAI .',
        tags: ['NODE JS', 'Express', 'EJS'],
        code: 'https://github.com/shaheedulaslam/alqaziStudio',
        demo: 'www.alqazi-studio.site',
        image: 'https://img.freepik.com/free-vector/cartoon-photographer-taking-photo-parents-kid-studio_74855-19730.jpg'
    },
    {
        id: 3,
        projectName: 'BRIDGEON-LMS (In Development)',
        projectDesc: 'This project Is a Live Project.',
        tags: ['REACT JS', 'NODE JS'],
        code: '',
        demo: '',
        image: 'https://img.freepik.com/premium-vector/web-development-programming-languages-css-html-it-ui-programmer-cartoon-character-developing-website-coding-flat-illustration-banner_128772-898.jpg'
    }
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/